import {axiosUtil} from "../../../../utils/axios_util";

const APoolAllocationApi = {
    //分页查询A池
    manageAPoolPage(data:powerSearchData) {
        return axiosUtil({
            url: '/manager/call_initializer_number/pool/page',
            method: 'post',
            data,
            params: {
                page: data.page,
                size: data.size
            }
        })
    },
    //编辑A池
    editAPool(data:any) {
        return axiosUtil({
            url: `/manager/call_initializer_number/pool/edit/${data.no}`,
            method: 'post',
            data,
        })
    },
    //删除A池
    deleteAPool(data: string) {
        return axiosUtil({
            url: `/manager/call_initializer_number/pool/delete/${data}`,
            method: 'post',
            data
        })
    },
    //新增A池
    addAPool(data:any) {
        return axiosUtil({
            url: `/manager/call_initializer_number/pool/add`,
            method: 'post',
            data,
        })
    },
    //是否启用/禁用A池
    setAPoolEnable(data:any) {
        return axiosUtil({
            url: `/manager/call_initializer_number/pool/edit/${data.no}/${data.isEnable}`,
            method: 'post',
            data,
        })
    },
    //查看A池详情：查看拥有权限的用户列表
    getAPoolDetail(data:any) {
        return axiosUtil({
            url: `/manager/call_initializer_number/pool/detail/${data.no}`,
            method: 'post',
            data,
        })
    },
}

export default APoolAllocationApi
